import { render, staticRenderFns } from "./EducationalGroupAttendanceAdd.vue?vue&type=template&id=4826fd14&"
import script from "./EducationalGroupAttendanceAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports